import React from 'react'
import { useFormikContext } from 'formik'
import { BasicSwitch } from '../BasicSwitch'

interface Props<T> {
  name: keyof T
  label: string
  description?: string
  disabled?: boolean
}

export const FormikSwitch = <T extends unknown>({
  name,
  label,
  description,
  disabled,
}: Props<T>) => {
  const { values, handleChange } = useFormikContext<T>()

  return (
    <BasicSwitch
      name={name as string}
      label={label}
      description={description}
      checked={values[name] as unknown as boolean}
      disabled={disabled}
      onChange={handleChange(name as string)}
    />
  )
}
